import { isNumeric } from '../../util/helpers';

import { BusinessFuel, FuelType, ServiceType } from '../../business/models/business-fuel.model';


/**
 * Fuel availability summary for airport, including minimum fuel price for the given fuel type and service type.
 */
export class AirportFuelSummary {
  /**
   * Fuel type (100LL, Jet-A, etc.)
   */
  fuelType: FuelType;

  /**
   * Fuel service type (full-serve vs self-serve)
   */
  service: ServiceType;

  /**
   * Fuel price (per gallon)
   */
  price: number;

  /**
   * Parses airport fuel summary
   * @param data {any} Airport fuel summary as returned by API
   * @return {BusinessFuel} Parsed airport fuel symmary
   */
  static parse(data: any): AirportFuelSummary {
    return Object.assign(new AirportFuelSummary(), {
      fuelType: BusinessFuel.parseFuelType(data.fuelType),
      service: BusinessFuel.parseServiceType(data.service),
      price: isNumeric(data.price) ? +data.price : null
    });
  }
}
